/* global process */
/* eslint no-console: 0 */

export default function() {
  if (process.env.NODE_ENV === "development") {
    return 'console' in window ? console.log.apply(console, arguments) : null;
  }
}
